export default [
  {
    id: 'built_in',
    brand: 'piriod',
    countries: ['CL'],
    description: 'La solución de Piriod para la emisión de documentos tributarios electrónicos en Chile.',
    docs: '/integrations/billers/facturacion-incorporada',
    routeName: 'BillersBuiltInSettings',
    invoiceTypes: [
      'Factura electrónica',
      'Factura exenta electrónica',
      'Factura electrónica de exportación',
      'Boleta electrónica',
      'Boleta electrónica exenta'
    ],
    otherTypes: [
      'Nota de crédito electrónica',
      'Nota de crédito electrónica de exportación',
      'Nota de débito electrónica',
      'Nota de débito electrónica de exportación'
    ],
    name: 'Facturación incorporada',
    website: 'https://www.piriod.com'
  },
  {
    id: 'facturapi',
    apiKeyLabel: 'Api Key',
    brand: 'facturapi',
    countries: ['MX'],
    description: 'API siempre al día para emitir y timbrar todo tipo de CFDI y complementos del SAT',
    docs: '/integrations/billers/facturapi',
    invoiceTypes: [
      'Factura de ingreso',
      'Factura de pago'
    ],
    otherTypes: [],
    routeName: 'IntegrationsFacturapi',
    name: 'Facturapi',
    website: 'https://www.facturapi.io'
  },
  {
    id: 'defontana',
    apiKeyLabel: 'Email',
    brand: 'defontana',
    countries: ['CL'],
    description: 'Facturación de suscripciones conéctada a las soluciones contables de Defontana.',
    docs: '/integrations/billers/defontana',
    invoiceTypes: [
      'Factura electrónica',
      'Factura exenta electrónica',
      'Boleta electrónica',
      'Boleta electrónica exenta'
    ],
    otherTypes: [
      'Nota de crédito electrónica',
      'Nota de débito electrónica'
    ],
    routeName: 'IntegrationsDefontana',
    name: 'Defontana',
    website: 'https://www.defontana.com'
  },
  {
    id: 'bsale',
    apiKeyLabel: 'Access Token',
    brand: 'bsale',
    countries: ['CL'],
    description: 'Emite documentos tributarios electrónicos en Chile a través de Bsale.',
    docs: '/integrations/billers/bsale',
    invoiceTypes: [
      'Factura electrónica',
      'Factura exenta electrónica',
      'Boleta electrónica',
      'Boleta electrónica exenta'
    ],
    otherTypes: [
      'Nota de crédito electrónica',
      'Nota de débito electrónica'
    ],
    routeName: 'BillersBiller',
    name: 'Bsale',
    website: 'https://www.bsale.cl'
  },
  {
    id: 'nfe',
    apiKeyLabel: 'Api Key',
    brand: 'nfe',
    countries: ['BR'],
    description: 'Emite notas fiscales de servicio en Brasil a partir de suscripciones y facturas únicas.',
    docs: '/integrations/billers/nfe.io',
    invoiceTypes: [
      'Nota fiscal de servicio'
    ],
    otherTypes: [],
    routeName: 'IntegrationsNfe',
    name: 'NFE.io',
    website: 'https://www.nfe.io'
  },
  {
    id: 'plemsi',
    apiKeyLabel: 'Api Key',
    brand: 'plemsi',
    countries: ['CO'],
    description: 'API siempre al día para emitir y timbrar todo tipo de CFDI y complementos del SAT',
    docs: '/integrations/billers/plemsi',
    invoiceTypes: [
      'Factura de venta nacional',
      'Documento de soporte'
    ],
    name: 'Plemsi',
    otherTypes: [],
    routeName: 'IntegrationsPlemsi',
    taxAgencies: ['dian'],
    website: 'https://www.plemsi.com'
  },
  {
    id: 'b2brouter',
    apiKeyLabel: 'Api Key',
    brand: 'b2brouter',
    countries: ['ES'],
    description: 'Una forma más sencilla de habilitar el intercambio de facturas compatibles con Verifactu',
    docs: '/integrations/billers/b2brouter',
    invoiceTypes: [
      'Factura'
    ],
    name: 'b2brouter',
    otherTypes: [],
    routeName: 'IntegrationsB2BRouter',
    taxAgencies: ['dian'],
    website: 'https://www.b2brouter.com'
  }
]